// extracted by mini-css-extract-plugin
export default {"Contain":"BackVideoText_Contain__w9sqB","sec":"BackVideoText_sec__2EnV1"};